import React, { Component } from 'react'
import { PageContainerLayout, PageHeaderLayout } from '../../../layouts'
import { NavLink } from 'react-router-dom'
import * as ROUTING_PATHS from '../../../../routing/Paths'
import { PermissionShape } from '../../../../prop-types'
import * as permissionOperations from '../../../../state/ducks/permissions/actions'
import connect from 'react-redux/es/connect/connect'
import * as PropTypes from 'prop-types'
import { PermissionDetailsCard, PermissionTimelineCard } from '../../../shared/containers'

class PermissionDetailsPage extends Component {
  constructor (props) {
    super(props)
  }

  UNSAFE_componentWillMount () {
    this.props.getPermission(this.props.match.params.permission_id)
  }

  renderHeaderPaths () {
    return (
            <>
                <li>
                    <NavLink className="link-effect" to={ROUTING_PATHS.PERMISSIONS_PATH}>
                        Permissions
                    </NavLink>
                </li>
                <li>Permission Details</li>
            </>
    )
  }

  render () {
    return (
            <>

                <PageContainerLayout>
                    <PageHeaderLayout
                        title={this.props.permission.codename}
                        subTitle={'Permission Details'}
                        paths={this.renderHeaderPaths}
                    />
                    <div className="content content-boxed">
                        <div className="row">
                            <div className="col-sm-12 col-lg-5">
                                {/* Details */}
                                <PermissionDetailsCard permission={this.props.permission}/>
                                {/* END Details */}
                            </div>
                            <div className="col-sm-12 col-lg-7">
                                {/* Timeline */}
                                <PermissionTimelineCard permission={this.props.permission}/>
                                {/* END Timeline */}
                            </div>
                        </div>
                    </div>
                </PageContainerLayout>

            </>
    )
  }
}

// Set propTypes
PermissionDetailsPage.propTypes = {
  permission: PermissionShape,
  getPermissionErrorResponse: PropTypes.object
}

// Set defaultProps
PermissionDetailsPage.defaultProps = {
  permission: { permissions: [], users: [] },
  getPermissionErrorResponse: {}
}

// mapStateToProps
const mapStateToProps = (state) => ({
  permission: state.permissions.getPermissionReducer.data,
  isLoading: state.permissions.getPermissionReducer.loading,
  getPermissionErrorResponse: state.permissions.getPermissionReducer.error_data
})

// mapStateToProps
const mapDispatchToProps = {
  getPermission: permissionOperations.get
}

// Export Class
const _PermissionDetailsPage = connect(mapStateToProps, mapDispatchToProps)(PermissionDetailsPage)
export { _PermissionDetailsPage as PermissionDetailsPage }
